import { getNestedFolders } from '../../assets/fileTree';
import getTree  from '../../assets/getTree';
import folder from '../../common/folder';

const getFolderTree = (folders: folder[]) => {
	const rootFolders = folders.filter((e) => e.parent_folder === null);
	const paths: string[][] = [];
	rootFolders.forEach((e) => {
		paths.push([e.title, e.folder_uid]);
		const nestedFolders = getNestedFolders(e.folder_uid, folders);
		nestedFolders.forEach((i) => {
			paths.push([
				`${getTree(i, e.folder_uid, folders)}/${i.title}`,
				i.folder_uid,
			]);
		});
	});
	return paths;
};

const FoldersMethods = {
	getFolderTree,
};

export default FoldersMethods;
